<script>
	const utilities = require('utilities');

	module.exports = {
		components: {
			modal: require('components/modal.vue').default
		},
		methods: {
			onOkClick() {
				utilities.closeModals();
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	#modal-download-assignment {
	}
</style>
<template>
	<modal
		ref="modal"
		id="modal-offline-assignment-submitted"
		:ok="false"
		:centered="true"
		:loading="loading">
		<template slot="header-container">
			<h2>Go online to finish submitting</h2>
		</template>
		<div
			slot="content"
			class="modal-offline-assignment-submitted">
			<p>
				Your teacher will only receive your submitted assignment after you connect to the internet and switch your account from offline to online mode.
			</p>
			<p>
				<button
					class="button"
					@click="onOkClick">
					Ok
				</button>
			</p>
		</div>
	</modal>
</template>
